import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import SettingsPageLayout from './SettingsPageLayout';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';

const AccountManagement = () => (
  <SettingsPageLayout
    title="Account Management"
    description="Manage account settings, subscription, and billing preferences."
  >
    <Paper
      variant="outlined"
      sx={{
        p: 5,
        borderRadius: 3,
        border: '1px dashed',
        borderColor: 'divider',
        bgcolor: 'background.default',
        textAlign: 'center',
        boxShadow: 'none',
      }}
    >
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 3, flexWrap: 'wrap' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'text.secondary' }}>
          <PersonAddIcon fontSize="small" />
          <Typography variant="body2">User invitations</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'text.secondary' }}>
          <ManageAccountsIcon fontSize="small" />
          <Typography variant="body2">Account roles</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'text.secondary' }}>
          <SubscriptionsIcon fontSize="small" />
          <Typography variant="body2">Subscription</Typography>
        </Box>
      </Box>
      <Typography variant="body1" sx={{ fontSize: 15, color: 'text.secondary', lineHeight: 1.6 }}>
        Coming soon. You can manage team members in Team Organization in the meantime.
      </Typography>
    </Paper>
  </SettingsPageLayout>
);

export default AccountManagement;
